const FREE_IDS = [
  144, 17, 6,       // monday
  349, 182, 3,      // tuesday
  318, 201, 357,    // wednesday
  327, 348, 320,    // thursday
  419, 4, 358,      // friday
  320, 188, 341,    // saturday
  145, 322, 342     // sunday
];

export function isFreeMusic(id: number): boolean {
  return FREE_IDS.includes(id);
}

export { FREE_IDS }; 